import { useEffect, useState } from "react";
import { http, formatErr } from "../../lib/api";
import { usePolling } from "../../lib/usePolling";
import { toast } from "sonner";

function thisMonth() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export default function AgentCommissions() {
  const [month, setMonth] = useState(thisMonth());
  const [data, setData] = useState(null);
  const [blocked, setBlocked] = useState(false);

  const load = async (m) => {
    try { const r = await http.get("/crm/me/commissions/month", { params: { month: m } }); setData(r.data); setBlocked(false); }
    catch (e) { if (e?.response?.status === 403) setBlocked(true); else toast.error(formatErr(e)); }
  };
  useEffect(() => {
    load(month);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [month]);
  usePolling(() => load(month), { interval: 10000, enabled: !blocked });

  if (blocked) return (
    <div data-testid="agent-commissions-blocked" className="max-w-2xl mx-auto card-clean p-6 text-center">
      <h1 className="font-serif text-2xl mb-2">Provvigioni</h1>
      <p className="text-sm text-neutral-600">Disponibili dopo l'attivazione del tuo account.</p>
    </div>
  );

  const svil = data?.sviluppo;
  return (
    <div data-testid="agent-commissions-page" className="max-w-4xl mx-auto">
      <div className="flex items-center justify-between mb-5 flex-wrap gap-3">
        <h1 className="font-serif text-3xl">Provvigioni</h1>
        <input type="month" value={month} onChange={(e) => setMonth(e.target.value)} data-testid="agent-comm-month"
          className="px-3 py-2 rounded-md border text-sm" style={{ borderColor: "var(--border-silver)" }} />
      </div>

      <div className="card-clean p-5 mb-5">
        <div className="flex gap-8 flex-wrap">
          <Stat label="Vendite valide" value={svil?.count ?? 0} testid="agent-comm-count" />
          <Stat label="Aliquota mese" value={svil ? `${Math.round(Number(svil.rate) * 100)}%` : "—"} testid="agent-comm-rate" />
          <Stat label="Netto da liquidare" value={svil ? `€ ${svil.net_outstanding}` : "—"} testid="agent-comm-net" />
        </div>
      </div>

      <div className="card-clean overflow-hidden" data-testid="agent-comm-table">
        <div className="px-4 py-3 border-b text-sm font-semibold" style={{ borderColor: "var(--border-silver)" }}>Sviluppo — {month}</div>
        {!svil || svil.lines.length === 0 ? <div className="p-6 text-sm text-neutral-500">Nessuna vendita nel mese.</div> : (
          <table className="w-full text-sm">
            <thead><tr className="text-left text-[10px] uppercase tracking-widest text-neutral-500 border-b" style={{ borderColor: "var(--border-silver)" }}>
              <th className="px-4 py-3">Salone</th><th className="px-4 py-3">Stato</th><th className="px-4 py-3">Diritto</th><th className="px-4 py-3">Liquidato</th><th className="px-4 py-3">Residuo</th>
            </tr></thead>
            <tbody>
              {svil.lines.map((l) => (
                <tr key={l.id} className="border-b last:border-0" style={{ borderColor: "var(--border-silver)" }}>
                  <td className="px-4 py-3">{l.salon_name || "—"} {l.cancelled && <span className="text-rose-700 text-xs">(annullata)</span>}</td>
                  <td className="px-4 py-3 text-neutral-500">{l.status}</td>
                  <td className="px-4 py-3">€ {l.entitlement}</td>
                  <td className="px-4 py-3">€ {l.settled}</td>
                  <td className="px-4 py-3">€ {l.outstanding}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {data?.altre?.length > 0 && (
        <div className="card-clean overflow-hidden mt-5" data-testid="agent-comm-others">
          <div className="px-4 py-3 border-b text-sm font-semibold" style={{ borderColor: "var(--border-silver)" }}>Mantenimenti / Extra (10%)</div>
          <table className="w-full text-sm">
            <tbody>
              {data.altre.map((o) => (
                <tr key={o.id} className="border-b last:border-0" style={{ borderColor: "var(--border-silver)" }}>
                  <td className="px-4 py-3 capitalize">{o.kind}</td><td className="px-4 py-3">{o.salon_name || "—"}</td>
                  <td className="px-4 py-3">€ {o.entitlement}</td><td className="px-4 py-3 text-neutral-500">{o.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

function Stat({ label, value, testid }) {
  return (
    <div>
      <div className="text-[10px] uppercase tracking-widest text-neutral-500">{label}</div>
      <div className="text-2xl font-semibold" data-testid={testid} style={{ color: "var(--brand-dark)" }}>{value}</div>
    </div>
  );
}
